export default {"src":"/_next/static/media/residential1.1327d676.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};